// extracted by mini-css-extract-plugin
export default {"input":"input--Ez6aE","editing":"editing--KSpMZ","enter":"enter--U4n03","delete":"delete--KoZrb"};